import React from 'react';
import PropTypes from 'prop-types';
import _, { result } from 'underscore';
import { StyledRecommendationBulkAAR } from '@bingads-webui-campaign-react/recommendation-bulk-aar';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getHistoryPageStyle } from '../style/history-page-style';

class recommendationsBulkAAR extends React.PureComponent {
  static propTypes = {
    navigateBack: PropTypes.func.isRequired,
    deps: PropTypes.shape({
      appConfig: PropTypes.objectOf(PropTypes.any).isRequired,
      i18n: PropTypes.PropTypes.shape({
        getString: PropTypes.func.isRequired,
      }).isRequired,
      preferencesService: PropTypes.objectOf(PropTypes.any).isRequired,
    }).isRequired,
    dataService: PropTypes.shape({
      getHistory: PropTypes.func.isRequired,
      downloadHistory: PropTypes.func.isRequired,
    }).isRequired,
    currentActivity: PropTypes.shape({
      trace: PropTypes.func.isRequired,
      error: PropTypes.func.isRequired,
    }).isRequired,
    perfMarker: PropTypes.shape({
      willInit: PropTypes.func.isRequired,
      willFetchData: PropTypes.func.isRequired,
      willRender: PropTypes.func.isRequired,
      done: PropTypes.func.isRequired,
      createChild: PropTypes.func.isRequired,
    }),
    newI18n: PropTypes.PropTypes.shape({
      getString: PropTypes.func,
    }).isRequired,
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    viewSummary: PropTypes.func.isRequired,
    serverContext: PropTypes.shape({}).isRequired,
    isAutoApplyRecommendationEnabled: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    perfMarker: {
      willInit: _.noop,
      willFetchData: _.noop,
      willRender: _.noop,
      done: _.noop,
      createChild: () => this,
    },
  };

  constructor(props) {
    super(props);
    this.perfMarker = props.perfMarker.createChild('RecommendationHistoryGridOverall');
    if (_.isFunction(this.perfMarker.willInit)) {
      this.perfMarker.willInit();
    }
    this.perfMarkerDone = false;
  }

  componentDidMount = () => {
    if (_.isFunction(this.perfMarker.willFetchData)) {
      this.perfMarker.willFetchData();
    }
    if (result(this.props.serverContext, 'IsProdEnv') && result(result(this.props.serverContext, ['CurrentCustomer']), ['Id']) !== 252258370) {
      this.props.viewSummary();
    }
  };

  componentDidUpdate = () => {
    if (!this.perfMarkerDone) {
      if (_.isFunction(this.perfMarker.done)) {
        this.perfMarker.done();
      }
      this.perfMarkerDone = true;
    }
  };

  render() {
    if (_.isFunction(this.perfMarker.willRender)) {
      this.perfMarker.willRender();
    }

    return (
      <div className={this.props.classes.BulkAARPageContainer}>
        <StyledRecommendationBulkAAR
          {...this.props}
          i18n={this.props.deps.i18n}
          newI18n={this.props.newI18n}
          navigateBack={this.props.navigateBack}
        />
      </div>
    );
  }
}

export const RecommendationsBulkAAR =
  withDefaultStyles((recommendationsBulkAAR), getHistoryPageStyle);
